<div
    #searchBarContainer
    class="traffic-logs-search-bar"
    *ngrxLet="trafficLogsStore.hasFilters$ as hasFilters"
>
    <cds-icon
        #searchIcon
        shape="search"
        size="18"
    ></cds-icon>

    <div
        class="traffic-logs-search-bar__input-container"
        avi-tooltip
        [positionsPriority]="dropdownPosition"
        [showOnControlOnly]="true"
        [tooltipControl$]="logsSearchBarDropdownService.dropdownControl$"
        [overlayMaxWidth]="dropdownWidth"
        (onBackdropClick)="logsSearchBarDropdownService.handleDropdownBackdropClick()"
    >
        <ng-container *ngrxLet="trafficLogsStore.filters$ as filters">
            <span
                class="traffic-logs-search-bar__filter-container"
                *ngFor="let filter of filters; index as i; trackBy: trackByIndex"
                [title]="filter"
            >
                <logs-editable-filter
                    [filter]="filter"
                    (onFilterOpen)="trafficLogsSearchBarStore.setEdit(i)"
                    (onFilterUpdate)="trafficLogsSearchBarStore.editFilter(i)"
                    (onFilterRemove)="trafficLogsStore.removeFilter(i)"
                ></logs-editable-filter>
            </span>
        </ng-container>

        <logs-filter-input
            class="traffic-logs-search-bar__input"
            [isPrimary]="true"
            (onSubmit)="trafficLogsSearchBarStore.addFilter()"
            (onBackspace)="trafficLogsSearchBarStore.handleBackspace()"
            (onKeydown)="handleSearchKeydown($event)"
            [placeholder]="hasFilters ? '' : (l10nKeys.filterPlaceholder | vtranslate)"
            [hidden]="trafficLogsSearchBarStore.isFilterBeingEdited$ | async"
        ></logs-filter-input>

        <ng-template #aviTooltipContent>
            <traffic-logs-search-bar-dropdown
                [dropdownWidth]="dropdownWidth"
                (onOptionsEscape)="handleEscapeDropdownOptions()"
            ></traffic-logs-search-bar-dropdown>
        </ng-template>
    </div>

    <cds-icon
        class="traffic-logs-search-bar__button"
        shape="times-circle"
        size="18"
        (click)="trafficLogsStore.removeAllFilters()"
        [hidden]="!hasFilters"
    ></cds-icon>
    <ng-container *ngrxLet="trafficLogsStore.isCurrentFilterSaved$ as isCurrentFilterSaved">
        <cds-icon
            *ngIf="hasFilters && !isCurrentFilterSaved"
            class="traffic-logs-search-bar__button"
            shape="star"
            size="18"
            (click)="openSaveSearchModal(SaveSearchTypeEnum.CREATE)"
        ></cds-icon>
        <cds-icon
            *ngIf="isCurrentFilterSaved"
            class="traffic-logs-search-bar__saved-search-star"
            shape="solid-star"
            size="18"
            (click)="openSaveSearchModal(SaveSearchTypeEnum.EDIT)"
        ></cds-icon>
    </ng-container>
    <ng-container *ngrxLet="trafficLogsStore.totalLogCount$ as totalLogCount">
        <ng-container *ngrxLet="trafficLogsStore.listLogCount$ as listLogCount">
            <div
                class="traffic-logs-search-bar__logs-label"
                [hidden]="trafficLogsStore.hasError$ | async"
            >
                <!-- If filters applied, the list log count will be displayed to match the number of logs fetched, with the filters, for the grid. -->
                <ng-container *ngIf="hasFilters">
                    {{ ((trafficLogsStore.tableIsLoading$ | async) ? '' : (l10nKeys.logCount | vtranslate : listLogCount)) }}
                </ng-container>

                <!-- If no filters applied, the total log count will be displayed to indicate the number of logs in the backend dataset. -->
                <ng-container *ngIf="!hasFilters">
                    {{ l10nKeys.logCount | vtranslate : totalLogCount }}
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
